import Component from 'Component';
import Route from "./tour/Route";
import Map from "./tour/Map";

export default class Tour extends Component {

  _namespace = this.constructor.name;

  _components = [
    // new Map(this.App, this._namespace),
    new Route(this.App, this._namespace),
  ];

  configure() {

    this.components.forEach((component) => {
      let name = component.constructor.name;
      this[name] = component.configure().initialize();
    });

    return super.configure();
  }

  get components() {
    return this._components;
  }

  initialize() {
    return super.initialize();
  }

}